export default "__VITE_ASSET__CyBczC21__"